module.exports = __webpack_public_path__ + "static/fonts/Mont-Regular.31fcd73.woff";